import { render, staticRenderFns } from "./ContactElements.vue?vue&type=template&id=7c145eba"
import script from "./ContactElements.vue?vue&type=script&lang=ts"
export * from "./ContactElements.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports